import axios from "axios";

export default function ({ route, redirect, $auth, $api }) {
  const existingPermAtStart = $auth?.$storage?.getState("perm");
  if (!Array.isArray(existingPermAtStart)) {
    $auth?.$storage?.setState("perm", []);
  }

  const isLocalDev = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  const isPublicAuthRoute =
    route.path == "/login/wachtwoord" ||
    route.path == "/login/wachtwoord/" ||
    route.path == "/login/wachtwoord/aanvragen/" ||
    route.path == "/login/wachtwoord/aanvragen" ||
    route.path == "/login/verifieer" ||
    route.path == "/login/verifieer/" ||
    route.path == "/login/uitnodiging/" ||
    route.path == "/login/uitnodiging" ||
    route.path == "/account/customer-register" ||
    route.path == "/account/customer-register/" ||
    route.path == "/account/registreren" ||
    route.path == "/account/registreren/";

  // During client refresh hydration, auth can be marked loggedIn before user is fully restored.
  // Do not force logout in that transient state.
  if ($auth.loggedIn && (!$auth.user || !$auth.user.uid)) {
    return;
  }

  // If user is not loggedin or UID does not exist. return to login.
  if (!$auth.loggedIn || !$auth.user.uid) {
    // Except these routes:
    if (isPublicAuthRoute) {
      // Allow these routes without authentication
      return;
    } else if (route.path != "/login" && route.path != "/login/") {
      return redirect("/login");
    }
    return;
  }

  // If on login page when logged in. Return to home page.
  if ($auth.loggedIn && (route.path == "/login" || route.path == "/login/")) {
    return redirect("/login/profielen");
  }
  
  // If logged in, always load permissions (also on localhost via proxy).
  if ($auth.loggedIn) {
    const profileId = $auth.user.profileId;
    // Use $api for authenticated requests
    $api
      .post('/companies/profile/get-permissions', {
        profileId: profileId,
      })
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          $auth.$storage.setState("perm", response.data);
        } else {
          $auth.$storage.setState("perm", [{ id: 0, name: "null" }]);
        }
      })
      .catch(() => {
        // Keep existing permissions on transient failures; only set fallback if nothing exists yet.
        const existingPerm = $auth.$storage.getState("perm");
        if (!Array.isArray(existingPerm) || existingPerm.length === 0) {
          $auth.$storage.setState("perm", [{ id: 0, name: "null" }]);
        }
      });
  }
  const ua = navigator;

  var hardwareConcurrency = '';
  var deviceMemory = '';
  var userAgent = '';

  if(navigator){
    if(navigator.hardwareConcurrency){
      hardwareConcurrency = navigator.hardwareConcurrency.toString();
    }
    if(navigator.deviceMemory){
      deviceMemory = navigator.deviceMemory.toString();
    }
    if(navigator.userAgent){
      userAgent = navigator.userAgent;
    }
  }

  var userDeviceID = hardwareConcurrency + deviceMemory + userAgent;
  if ($auth.loggedIn && !isLocalDev) {
    //Check if IP is the same
    // Use imported axios for external API (ipify)
    var resourcesUrl = "https://api.ipify.org?format=json";
    axios.get(resourcesUrl)
    .then(() => { 
    // Use $api for authenticated requests to our backend
    $api.post('/auth/check-ip', {
        ip: userDeviceID,
        id: $auth.user.id
    }).then((response) => {
        if(!response.data.exists){
            $auth.logout();
            // Note: This redirect happens asynchronously, so it may still show warning
            redirect('/login');
        }
    })
    }).catch(error => {
        if(error.response && !error.response.data.exists){ 
            $auth.logout();
            redirect('/login');
        }
    });
  }
}
